<div class="quiz-completion" [class.success-state]="passed">
    <div class="completion-card" [class.success-card]="passed">
        <div class="completion-header">
            <nav class="lesson-breadcrumbs" [attr.aria-label]="'studentLearningQuiz.breadcrumb_label' | translate">
                <button type="button" #backToLibraryBtn (click)="onBackToLibrary()" c11n-link
                    [variant]="'secondary-independent'">
                    {{ 'studentLearningQuiz.back_to_learning_library' | translate }}
                </button>
                <ng-container *ngIf="lessonTitle">
                    <span class="lesson-breadcrumb-separator" aria-hidden="true">/</span>
                </ng-container>
            </nav>
            <h1 class="quiz-title" [attr.aria-label]="lessonTitle">{{ lessonTitle }}</h1>
        </div>
        <div *ngIf="passed" class="completion-content success">
            <div class="upper-container">
                <div class="score-description">
                    <h2 class="completion-title">
                        {{ 'studentLearningQuiz.congrats' | translate }}
                    </h2>
                    <div class="score-badge">
                        <h2 class="score-text">{{ 'studentLearningQuiz.you_scored' | translate }} {{ percentage }}%</h2>
                    </div>
                </div>
            </div>
            <div class="action-buttons">
                <c11n-button [ariaLabelText]="'studentLearningQuiz.refresh_on_lesson' | translate"
                    [labelText]="'studentLearningQuiz.refresh_on_lesson' | translate" [variant]="'secondary'"
                    [size]="isXsScreen ? 'small' : 'medium'" (clickEvent)="onRevisitLesson()">
                </c11n-button>
                <c11n-button
                    [ariaLabelText]="('studentLearningQuiz.you_scored' | translate) + ' ' + percentage + '%, ' + ('studentLearningQuiz.back_to_library' | translate)"
                    [labelText]="'studentLearningQuiz.back_to_library' | translate" [variant]="'primary'"
                    [size]="isXsScreen ? 'small' : 'medium'" (clickEvent)="onBackToLibrary()">
                </c11n-button>
            </div>
        </div>

        <div *ngIf="!passed" class="completion-content failure">
            <div class="upper-container">

                <div class="score-description">
                    <h2 class="completion-title">
                        {{ 'studentLearningQuiz.every_mistake_title' | translate }}
                    </h2>
                    <div class="score-badge">
                        <h2 class="score-text">{{ 'studentLearningQuiz.you_scored' | translate }} {{ percentage
                            }}%</h2>
                    </div>
                </div>
            </div>
            <div class="action-buttons">
                <c11n-button [ariaLabelText]="'studentLearningQuiz.revisit_lesson' | translate"
                    [labelText]="'studentLearningQuiz.revisit_lesson' | translate" [variant]="'secondary'"
                    [size]="isXsScreen ? 'small' : 'medium'" [fullWidth]="true" (clickEvent)="onRevisitLesson()">
                </c11n-button>

                <c11n-button
                    [ariaLabelText]="('studentLearningQuiz.you_scored' | translate) + ' ' + percentage + '%, ' + ('studentLearningQuiz.retake_quiz' | translate)"
                    [labelText]="'studentLearningQuiz.retake_quiz' | translate" [variant]="'primary'"
                    [size]="isXsScreen ? 'small' : 'medium'" [fullWidth]="true" (clickEvent)="onRetakeQuiz()">
                </c11n-button>
            </div>
        </div>
    </div>
</div>